import { render, staticRenderFns } from "./ViewTaxGroupPage.vue?vue&type=template&id=22a9a08a"
import script from "./ViewTaxGroupPage.vue?vue&type=script&lang=js"
export * from "./ViewTaxGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports